<template>
  <div class="container-searchbox">
    <div class="content picture-tip">
      <img src="@/assets/downloads/goldLogo.png" @click="refresh" />
      <div class="context-search">
        <SubmitSearch ref="searchBox" :btnIsshow="false" />
      </div>
      <div class="remark-box">
        <div class="context-item">
          <img src="@/assets/downloads/telphone_icon.png" />
          <span @mouseenter="iphoneEnter" style="margin-left: 6px">手机版下载</span>
          <div class="max-remark-iphonebig" @mouseleave="iphoneLeave" v-show="iphoneVisible">
            <div v-bind:iscode="true" class="remake"></div>
            <span class="title">扫码即可下载手机APP</span>
            <div>
              <div style="display: flex; margin-bottom: 20px">
                <div class="max-remark-iphone">
                  <span class="text">经营帮</span>
                  <div class="max-remark-app">
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/android.png" />
                      <span>安卓</span>
                    </div>
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/ios.png" />
                      <span>IOS</span>
                    </div>
                  </div>
                </div>
                <div class="max-remark-iphone">
                  <span class="text">企管帮</span>
                  <div class="max-remark-app">
                    <div class="max-remark-samll">
                      <!-- <img width="100" height="100" ref="qgbqrCodeUrlAndir"/> -->
                      <div ref="qgbqrCodeUrlAndir"></div>
                      <span>安卓</span>
                    </div>
                    <div class="max-remark-samll">
                      <div ref="qgbqrCodeUrlIos"></div>
                      <span>IOS</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom: 20px">
                <div class="max-remark-iphone">
                  <span class="text">经营帮物流</span>
                  <div class="max-remark-app">
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/wuliuapp.png" />
                      <span>安卓</span>
                    </div>
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/wuliuapp.png" />
                      <span>IOS</span>
                    </div>
                  </div>
                </div>
                <div class="max-remark-iphone">
                  <span class="text">企联多</span>
                  <div style="margin-left: 20px">
                    <div class="max-remark-samll" style="border: 1px solid #e4e7ed">
                      <img src="@/assets/downloads/android.png" />
                      <span>安卓</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex">
                <div class="max-remark-iphone">
                  <span class="text">经营帮商城</span>
                  <div class="max-remark-app">
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/jyb-android.png" />
                      <span>安卓</span>
                    </div>
                    <div class="max-remark-samll">
                      <img src="@/assets/downloads/jyb-ios.png" />
                      <span>IOS</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="context-item">
          <img src="@/assets/downloads/wx_icon.png" />
          <span @mouseenter="wxEnter" style="margin-left: 6px">微信小程序</span>
          <div @mouseleave="wxLeave" class="max-remark-wxbig" v-show="wvVisible">
            <div v-bind:iscode="true" class="remake"></div>
            <div class="max-remark-samll-wx">
              <img src="@/assets/downloads/follow_wxremark.png" />
              <span>经营帮小程序</span>
            </div>
            <div class="max-remark-samll-wx">
              <img src="@/assets/downloads/wuliuWx.jpg" />
              <span>经营帮物流</span>
            </div>
          </div>
        </div>
        <div class="context-item">
          <img src="@/assets/downloads/telephon_cur_icon.png" />
          <span @mouseenter="curServeEnter" @mouseleave="curServeLeave" style="margin-left: 6px"
            >客服电话
          </span>
          <div v-show="cusServeVisible" @mouseleave="curServeLeave" class="cus_service_list">
            <ul>
              <li>
                <span>售前电话</span>
                <span class="list_phone">400-600-0115</span>
              </li>
              <li>
                <span>售后电话</span>
                <span class="list_phone">400-001-0051</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQgbAndroid } from '@/api/apiDownload';
import QRCode from 'qrcodejs2';
import link from "@/public/link.js"
export default {
  data() {
    return {
      wvVisible: false,
      iphoneVisible: false,
      cusServeVisible: false
    };
  },
  components: {
    SubmitSearch: () => import('@/components/public/components/SubmitSearch.vue')
  },
  created() {},
  mounted() {
    let that = this;
    document.body.addEventListener('click', function (e) {
      if (!e.target.getAttribute('iscode')) {
        that.iphoneLeave();
        that.wxLeave();
      }
    });
    this.$nextTick(() => {
      this.initQgbConf();
    });
  },
  methods: {
    curServeEnter() {
      this.cusServeVisible = true;
      this.iphoneLeave();
      this.wxLeave();
    },
    curServeLeave() {
      this.cusServeVisible = false;
    },
    wxEnter() {
      this.wvVisible = true;
      this.iphoneLeave();
    },
    wxLeave() {
      this.wvVisible = false;
    },
    iphoneEnter() {
      this.wxLeave();
      this.iphoneVisible = true;
    },
    iphoneLeave() {
      this.iphoneVisible = false;
    },
    blur() {
      this.$refs.searchBox.outBlur();
    },
    //点击logo,
    refresh() {
      window.open(`${process.env.VUE_APP_HOME}`, '_blank');
    },
    creatQrCode($el, content) {
      var qrcode = new QRCode($el, {
        text: content,
        width: 110,
        height: 110,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      console.log('qrcode', qrcode);
    },
    async initQgbConf() {
      let res = await getQgbAndroid();
      let download_url = res.data.data.download_url;
      this.creatQrCode(this.$refs['qgbqrCodeUrlAndir'], download_url);
      this.creatQrCode(
        this.$refs['qgbqrCodeUrlIos'],
        'https://apps.apple.com/us/app/qi-guan-bang/id1508999712?l=zh&ls=1'
      );
    }
  }
};
</script>

<style scoped lang="scss">
@keyframes searchTop {
  0% {
    top: -82px;
  }
  to {
    top: 0;
  }
}
@keyframes searchOutTop {
  0% {
    top: 0;
  }
  to {
    top: -82px;
  }
}
@media screen and (max-width: 1440px) {
  .max-remark-iphonebig {
    height: 600px;
    overflow-y: scroll;
  }
}
.container-searchbox {
  width: 100%;
  background: #fff;
  border: 1px solid #e0e3ea;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  top: -82px;
  &.search-fix {
    position: fixed;
    z-index: 2001;
    left: 0;
    top: 0;
    width: 100%;
    display: block;
    animation: searchTop 0.5s ease-in-out;
  }
  &.search-fixout {
    position: fixed;
    z-index: 100;
    left: 0;
    top: -82px;
    width: 100%;
    display: none;
    animation: searchOutTop 0.5s ease-in-out;
  }
  .picture-tip {
    position: relative;
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    display: flex;
    align-items: center;
    > img {
      width: 140px;
      height: 53px;
      cursor: pointer;
    }
    .context-search {
      margin-left: 90px;
      width: 456px;
      height: 40px;
      position: relative;
    }
    .remark-box {
      display: flex;
      justify-content: space-around;
      .context-item {
        position: relative;
        width: 170px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .max-remark-wxbig {
          width: 428px;
          height: 250px;
          background: #ffffff;
          box-shadow: 0px 2px 6px 2px rgba(164, 164, 164, 0.31);
          display: flex;
          position: absolute;
          top: 162%;
          left: 0;
          justify-content: space-evenly;
          align-items: center;
          .max-remark-samll-wx {
            width: 184px;
            height: 210px;
            border: 1px solid #b79255;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            > img {
              width: 144px;
              height: 144px;
            }
            > span {
              color: #333333;
              font-size: 14px;
            }
          }
        }
        .max-remark-iphonebig {
          width: 732px;
          background: #ffffff;
          box-shadow: 0px 2px 6px 2px rgba(164, 164, 164, 0.31);
          position: absolute;
          top: 162%;
          left: -147px;
          padding-bottom: 20px;
          z-index: 10000;
          .title {
            display: inline-block;
            height: 60px;
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            line-height: 60px;
          }
          .max-remark-iphone {
            width: 336px;
            height: 238px;
            background: #ffffff;
            box-shadow: 0px 2px 6px 0px rgba(204, 203, 202, 0.31);
            border: 1px solid #b79255;
            margin-left: 20px;
            .max-remark-app {
              display: flex;
              justify-content: space-evenly;
              .max-remark-samll {
                width: 138px;
                height: 164px;
                border: 1px solid #e4e7ed;
              }
            }
            > span {
              display: inline-block;
              font-size: 16px;
              font-weight: bold;
              color: #b79255;
              line-height: 21px;
              padding: 20px 127px;
            }
          }
        }
        .max-remark-samll {
          width: 138px;
          height: 164px;
          border: 1px solid #b79255;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          > img {
            width: 110px;
            height: 110px;
          }
          > span {
            color: #333333;
            font-size: 14px;
          }
        }
        .cus_service_list {
          position: absolute;
          width: 217px;
          height: 88px;
          background: #ffffff;
          box-shadow: 0px 2px 6px 2px rgba(164, 164, 164, 0.31);
          right: -6px;
          top: 46px;
          z-index: 22;
          background: #fff;
          ul {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            li {
              display: flex;
              align-items: flex-end;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              text-indent: 20px;
              > span {
                color: #666666;
                &.list_phone {
                  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                  columns: #333333;
                  text-indent: 10px;
                  font-weight: 700;
                }
              }
            }
          }
        }
        > span {
          display: inline-block;
          color: #666;
          font-size: 14px;
          &:first-of-type {
            margin-right: 12px;
          }
          &:hover {
            color: #b79255;
            cursor: pointer;
          }
        }
        > img {
          width: 26px;
          height: 26px;
        }
        .connect {
          color: #b79255;
        }
      }
    }
  }
}
.remake {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
